//import "antd/dist/antd.css";
import "antd/dist/antd.min.css";
import "rc-dropdown/assets/index.css";
import "rc-pagination/assets/index.css";
import "rc-slider/assets/index.css";
import React from "react";
import "react-datetime/css/react-datetime.css";
// import ReactDOM from "react-dom";
import "boxicons/css/boxicons.min.css";
import "react-dropdown/style.css";
import "react-image-crop/dist/ReactCrop.css";
import "react-phone-input-2/lib/style.css";
import "react-responsive-modal/styles.css";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
const queryClient = new QueryClient();
const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
	<QueryClientProvider client={queryClient}>
		<App />
	</QueryClientProvider>
);

// ReactDOM.render(
// 	<React.StrictMode>
// 		<App />
// 	</React.StrictMode>,
// 	document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
